const tickers = document.querySelectorAll('.ticker')

if (tickers.length) {
    const ticker = tickers[0]
    const clone = ticker.cloneNode(true)
    ticker.parentNode.insertBefore(clone, ticker.nextSibling)
}
